/** URL のドメインから判定した販売プラットフォームの表示情報。 */
export interface StorePlatform {
  key: string;
  label: string;
}

/** ドメイン → プラットフォーム表記のマッピング。サブドメイン（xxx.booth.pm 等）も吸収する。 */
const PLATFORM_DOMAINS: { domain: string; key: string; label: string }[] = [
  { domain: 'booth.pm', key: 'booth', label: 'Booth' },
  { domain: 'gumroad.com', key: 'gumroad', label: 'Gumroad' },
  { domain: '3d.nicovideo.jp', key: 'niconi-solid', label: 'ニコニ立体' },
  { domain: 'hub.vroid.com', key: 'vroid-hub', label: 'VRoid Hub' },
  { domain: 'fanbox.cc', key: 'fanbox', label: 'FANBOX' },
  { domain: 'fantia.jp', key: 'fantia', label: 'Fantia' },
  { domain: 'skeb.jp', key: 'skeb', label: 'Skeb' },
  { domain: 'stores.jp', key: 'stores', label: 'STORES' },
];

/**
 * 関連商品URL からプラットフォームを判定する。既知ドメイン（サブドメイン含む）なら対応する
 * key/label を返し、URL として不正な場合は null、未知ドメインの場合は汎用リンクとして扱う。
 */
export function detectStorePlatform(url: string): StorePlatform | null {
  let hostname: string;
  try {
    hostname = new URL(url.trim()).hostname.toLowerCase();
  } catch {
    return null;
  }

  for (const { domain, key, label } of PLATFORM_DOMAINS) {
    if (hostname === domain || hostname.endsWith(`.${domain}`)) {
      return { key, label };
    }
  }

  return { key: 'link', label: hostname.replace(/^www\./, '') };
}
